import { CarouselObjects } from '../predefinedObjects/CarouselObjects';
import 'owl.carousel';
import 'owl.carousel2.thumbs';

class Carousels {

    constructor(){
       this.initCarousels();
    };

    initCarousels () {
        CarouselObjects.map((data) => {
            data.type === 'owl' ? this.initOwlCarousel(data) : null ;
        });
    };

    initOwlCarousel(data){
       data.selector.owlCarousel(data.config);
       data.config.thumbs ? this.enableThumbs(data.selector) : null;
    };

    enableThumbsSliding(data, singleWidth, width, elems){



	    data.on('changed.owl.carousel', function(event) {
            let margin = 40;
            let centerElem = 3;
            let moveIndex = $('.owl-thumb-item.active').data('elem');
            let moveVal = (parseFloat(moveIndex) - centerElem);
            let moveBy = 0;

           // moveIndex <= centerElem ? moveBy = -40 : moveIndex >= (elems.length - 4) ? moveBy =  elems.length - 1 * singleWidth : moveBy = (moveVal * singleWidth) + ( (moveVal - 1) *40);

            if ( moveIndex <= centerElem) {
                moveBy = - margin;
			} else {
                if ( moveIndex >= (elems.length - 4) ) {
                    moveBy =  ((elems.length - 7) * singleWidth) + ( (elems.length - 8) * margin);
				}else{
                    moveBy = (moveVal * singleWidth) + ( (moveVal - 1) * margin);
				}
			}

            $('.owl-thumbs').css({left: - (moveBy)});
    	});
    };

    enableThumbs(data){
	    let elems = document.getElementsByClassName('owl-thumb-item');

	    if (elems.length > 0){
	    	let containerWidth = parseFloat($('.owl-stage-outer').outerWidth()) - (8 * 40);

	    	let singleWidth = containerWidth / 7;
		    $('.owl-thumb-item').css({ width : singleWidth, maxHeight : '100px', overflow : 'hidden' });
		    let width = (elems.length * singleWidth) + (elems.length * 40);

		    for (let i = 0; i < elems.length; i++){
			    $(elems[i]).attr('data-elem', i);
		    }

		    $('.owl-thumbs').wrap('<div class="owl-thumbs-background"><div class="owl-thumbs-wrapper"></div></div>').css({ width : width});

		    elems.length > 7 ? this.enableThumbsSliding(data, singleWidth, width, elems) : null;
	    }
    };
}

export { Carousels };


// WEBPACK FOOTER //
// ./js/core/carousels.js